import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import logoIcon from '../assets/images/logo-icon.png';
import logoTextOnDark from '../assets/images/logo-text-ondark.png';
import logoTextOnLight from '../assets/images/logo-text-onlight.png';
import '../styles/components/LogoMark.scss';

const LogoMark = ({ to, iconHeight = 44, textHeight = 26, className = '' }) => {
  const { theme } = useTheme();
  const wordmark = theme === 'light' ? logoTextOnLight : logoTextOnDark;

  return (
    <Link to={to} className={`logo-mark ${className}`}>
      <img src={logoIcon} alt="" className="logo-mark-icon" style={{ height: iconHeight }} />
      <img src={wordmark} alt="yeniders.com" className="logo-mark-text" style={{ height: textHeight }} />
    </Link>
  );
};

export default LogoMark;
